<template>
      <van-goods-action>
      <!-- <van-goods-action-icon :icon="require('../../assets/icon/service2.png')" text="客服" @click="showService" /> -->
      <component 
      v-for="(item, index) of displayGoodsActionItem"
      :color="item.color"
      :key="index"
      :is="item.component"
      :text="item.text"
      :icon="item.icon"
      @click="clickHandle(item.action, item.type)"
      >
      </component>
      <!-- <van-goods-action-icon  :icon="require('@/assets/icon/car.png')" text="购物车" to="/tabbar/car" />
      <van-goods-action-button color="#FFC44E" type="warning" text="加入购物车" @click="addcar" />
      <van-goods-action-button color="#FF6161" type="danger" text="立即购买" @click="buyNow" /> -->
    </van-goods-action>
</template>
<script>
import { addcar } from '@/api/car'
import { mapMutations, mapState } from 'vuex'

const goodsActionItem = [
  {
    
    icon: require('@/assets/icon/car.png'),
    text: '购物车',
    action: 'Car',
    component: 'van-goods-action-icon',
    color: '',
    type: 'link'
  },
  {
    icon: '',
    color: '#FFC44E',
    type: 'warning',
    text: '加入购物车',
    component: 'van-goods-action-button',
    action: 'addcar',
    type: 'button'
  },
  {
    icon: '',
    color: '#FF6161',
    type: 'danger',
    text: '立即购买',
    component: 'van-goods-action-button',
    action: 'buyNow',
    type: 'button'
  }
]

export default {
  props: {
    goods: {
      type: Object,
      // default: 1
    },
    premission: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      goodsActionItem
    }
  },
  computed: {
    displayGoodsActionItem () {
      if (this.premission.length === 0) {
        return this.goodsActionItem
      } else {
        return this.goodsActionItem.filter(item => {
           return this.premission.includes(item.action)
         })
      }
    },
    ...mapState('payment', ['paymentType'])
  },
  methods: {
    ...mapMutations('payment', ['SET_PAYINFO']),
     // 点击添加购物车
    async addcar () {
      const { goods, $toast, $router } = this
      if (goods.goodstatus === 0) {
        $toast('商品已下架')
        $router.go(-1)
        return
      }
      const result = await addcar({
        goods_sn: goods.goods_sn,
        num: 1
      })
      this.$toast(result.data.data.message)
    },
    // 点击现在购买
    buyNow () {
      const { goods, $toast, $router } = this
      if (goods.goodstatus === 0) {
        $toast('商品已下架')
        $router.go(-1)
        return
      }
      this.SET_PAYINFO({
        payInfo: [goods.goods_sn],
        payType: this.paymentType['buyNow']
      })
      $router.push('/payment')
    },
    clickHandle (item, type) {
      if (type === 'link') {
        this.$router.push({
          name: item
        })
      }
      if (type === 'button') {
        this[item]()
      }
    }
  },
}
</script>